<div class="content">
  <mat-accordion multi="false">
    <ng-container *ngFor="let ranch of (ranches | async)">
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title><h2>{{ ranch.ranch.title }}</h2>
            <!-- <ng-container *ngIf="showId">({{ ranchWithUser.ranch.id }})</ng-container> -->
          </mat-panel-title>
        </mat-expansion-panel-header>

        <section>
          <div>
            <h3>Members</h3>
            <mat-list>
              <ng-container *ngFor="let user of ranch.users">
                <mat-list-item class="ranchMember">
                  <p mat-line><span>Name:</span> {{ user.firstName }} {{ user.lastName }}
                    <ng-container *ngIf="user.id == ranch.ranch.ownerId"> - owner</ng-container>
                  </p>
                  <p mat-line><span>Username:</span> {{ user.userName }}</p>
                  <p mat-line><span>Email:</span> {{ user.email }}</p>
                  <p mat-line *ngIf="user.ranchManager">Foreman</p>

                  <button mat-icon-button aria-label="Edit" color="primary" (click)="openUserDetails(user, ranch)"
                          class="editbtn">
                    <mat-icon>edit</mat-icon>
                  </button>

                </mat-list-item>
                <mat-divider></mat-divider>
              </ng-container>
            </mat-list>
            <button mat-flat-button color="primary" (click)="addNewUserToRanch(ranch)">
              <mat-icon>add</mat-icon>
              Add User
            </button>
          </div>

          <div>
            <h3>Boundaries</h3>
            <mat-list
              *ngIf="!!ranch.ranch && ((boundariesObs | async)?.length || (ranch.ranch.sharedBoundaries?.length>0))">
              <ng-container *ngFor="let boundary of ranch.ranch.sharedBoundaries">
                <ng-container *ngIf="boundary.visible">
                  <mat-list-item>
                    <mat-checkbox
                      [disabled]="boundary.ownerId !=(currentUserObs|async)?.id"
                      [checked]="isBoundaryShared(boundary, ranch)"
                      (change)="selectedBoundaryChanged($event, ranch)"
                      [value]="boundary.id">{{ boundary.title }}
                    </mat-checkbox>
                  </mat-list-item>
                </ng-container>
              </ng-container>
              <ng-container *ngFor="let boundary of (boundariesObs | async)">
                <mat-list-item>
                  <mat-checkbox
                    [checked]="isBoundaryShared(boundary, ranch)"
                    (change)="selectedBoundaryChanged($event, ranch)"
                    [value]="boundary.id">{{ boundary.title }}
                  </mat-checkbox>
                </mat-list-item>
              </ng-container>
            </mat-list>
          </div>

          <div>
            <h3>Subscriptions</h3>
            <ng-container *ngFor="let sub of (ownedModuleSubscriptionsObs | async)[ranch.ranch.id]">
              <mat-list-item>
                {{ sub.title }}
              </mat-list-item>
              <!-- <mat-divider></mat-divider> -->
            </ng-container>
          </div>
        </section>

      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
</div>
